import {IDataHeader} from '../interfaces/data-header.interface';

export class DataHeader {
    public label: string;
    public selector: string;
    public colspan: number;
    public shifted: boolean;
    public sortIndex: number;
    public sortable: boolean;

    constructor(data: IDataHeader) {
        this.label = data.label;
        this.selector = data.selector;
        this.shifted = data.shifted;
        this.colspan = !data.colspan ? 1 : data.colspan;
        this.sortIndex = !data.sortIndex ? 0 : data.sortIndex;
        this.sortable = data.sortable;
    }
}
